<h2 mat-dialog-title class="default-dialog-header font-weight-normal">{{ data.title }}</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="p-8" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="1rem">
		<mat-form-field style="width: 100%">
			<input
				[formControl]="formContent"
				placeholder="{{ data.placeholder }}"
				matInput
				type="text"
			/>
		</mat-form-field>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end center">
		<span (click)="closeDialog()" class="link m-r-1 primary-text"> Cancel </span>
		<button (click)="confirm()" color="primary" mat-raised-button>Save</button>
	</div>
</mat-dialog-actions>
